import { Route, Routes, type RouteProps } from "react-router-dom";
import { getAppRoutes, getAuthRoutes, type RoutesProps } from ".";
import AdminLayout from "../layout/AdminLayout";
import OtherLayout from "../layout/OtherLayout";
import { Suspense } from "react";
import AuthProvider from "@/services/providers/authProvider";
import FullScreenLoader from "@/components/loaders/screenLoader";

/** Nested routes render inside their parent route's element, through its `<Outlet>`. */
const renderChildRoutes = (routes: RoutesProps[] = []) =>
  routes.map((route, idx) =>
    route.index ? (
      <Route key={idx + route.name} index element={route.element} />
    ) : (
      <Route key={idx + route.name} path={route.path} element={route.element}>
        {renderChildRoutes(route.children)}
      </Route>
    )
  );

export const AppRouter = (props: RouteProps) => {
  const appRoutes = getAppRoutes();
  const authRoutes = getAuthRoutes();

  return (
    <Suspense fallback={<FullScreenLoader />}>
      <Routes>
        {(authRoutes || []).map((route, idx) => (
          <Route
            key={idx + route.name}
            path={route.path}
            element={<OtherLayout {...props}>{route.element}</OtherLayout>}
          />
        ))}

        {appRoutes.map((route, idx) => (
          <Route
            key={idx + route.name}
            path={route.path}
            element={
              <AuthProvider>
                <AdminLayout {...props}>{route.element}</AdminLayout>
              </AuthProvider>
            }
          >
            {renderChildRoutes(route.children)}
          </Route>
        ))}
      </Routes>
    </Suspense>
  );
};
export default AppRouter;
